import React from "react";
import { makeStyles } from "@material-ui/core";
import GroupIcon from "@material-ui/icons/Group";

import {
  getChatTitle,
  getInitials,
  isDirectChat,
  otherMembers,
  userColor,
} from "./chatUtils";

const useStyles = makeStyles((theme) => ({
  wrap: {
    position: "relative",
    flexShrink: 0,
    display: "inline-flex",
  },
  circle: {
    borderRadius: "50%",
    color: "#fff",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
  },
  dot: {
    position: "absolute",
    right: 0,
    bottom: 0,
    borderRadius: "50%",
    boxSizing: "border-box",
    border: `2px solid ${theme.palette.background.paper}`,
  },
}));

export function UserAvatar({ id, name, size = 40, online, showStatus }) {
  const classes = useStyles();
  const dot = Math.max(10, Math.round(size * 0.28));
  return (
    <span className={classes.wrap}>
      <span
        className={classes.circle}
        style={{
          width: size,
          height: size,
          fontSize: Math.round(size * 0.34),
          backgroundColor: userColor(id),
        }}
        aria-hidden="true"
      >
        {getInitials(name)}
      </span>
      {showStatus && (
        <span
          className={classes.dot}
          style={{
            width: dot,
            height: dot,
            backgroundColor: online ? "#1E9E5A" : "#A3ACB9",
          }}
          title={online ? "Online" : "Offline"}
        />
      )}
    </span>
  );
}

// Avatar de uma conversa: a pessoa (direta) ou ícone de grupo
export default function ChatAvatar({ chat, userId, size = 42 }) {
  const classes = useStyles();

  if (isDirectChat(chat)) {
    const other = otherMembers(chat, userId)[0];
    return (
      <UserAvatar
        id={other?.userId}
        name={other?.user?.name || getChatTitle(chat, userId)}
        online={other?.user?.online}
        size={size}
        showStatus
      />
    );
  }

  return (
    <span className={classes.wrap}>
      <span
        className={classes.circle}
        style={{
          width: size,
          height: size,
          // deslocado para o grupo não repetir a cor da pessoa de mesmo id
          backgroundColor: userColor((chat?.id || 0) + 3),
        }}
        aria-hidden="true"
      >
        <GroupIcon style={{ fontSize: Math.round(size * 0.5) }} />
      </span>
    </span>
  );
}
